import styled from 'styled-components/macro'

import { getToken, toCSSValue } from '@loadsmart/miranda-react/dist/tokens'

import { screen } from 'legacy/styles/screen'

export const Wrapper = styled.div`
  background-color: ${toCSSValue('color-background-primary')};
  border: ${getToken('border-thin')} solid ${toCSSValue('color-border')};
  border-radius: ${getToken('border-radius-s')};
`

export const DeadlineWrapper = styled.div`
  padding: ${getToken('spacing-3')} ${getToken('spacing-6')};
  border-bottom: ${getToken('border-thin')} solid ${toCSSValue('color-border')};
`

export const Body = styled.div`
  padding: ${getToken('spacing-6')};
`

export const ShipperInfoWrapper = styled.div`
  flex-basis: 150px;
  flex-shrink: 1;
  flex-grow: 0;

  ${screen.md} {
    flex-grow: 1;
  }
`

export const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;

  gap: ${getToken('spacing-3')};
`
